import React from 'react';
import { getSortIndicator } from '../../utils/serverTableSort';

const SortableTh = ({
  column,
  sorting,
  onSortChange,
  children,
  className = '',
  title,
}) => (
  <th
    className={`workflow-sortable ${className}`.trim()}
    onClick={() => onSortChange(column)}
    title={title || `Click to sort by ${children}`}
  >
    {children}
    {getSortIndicator(sorting, column)}
  </th>
);

export default SortableTh;
